import { render } from "./CommonAuthorThree.vue?vue&type=template&id=23ccd7a6"
import script from "./CommonAuthorThree.vue?vue&type=script&lang=js"
export * from "./CommonAuthorThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__